import React from 'react'
import { createBrowserHistory } from 'history'
import { StateProvider } from '../state'
import ButterToast, { POS_TOP, POS_RIGHT } from 'butter-toast'
import { TemplateTables } from './TemplateTables'

export const history = createBrowserHistory()

export const App = ({ badgeDesigns, badges, certDesigns, certificates }) => {
  const initialState = {
    badgeDesigns: badgeDesigns,
    badges: badges,
    certificateDesigns: certDesigns,
    certificates: certificates,
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'updateCerts':
        return {
          ...state,
          certificates: action.payload,
        }
      case 'updateBadges':
        return {
          ...state,
          badges: action.payload,
        }
    }
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <ButterToast
        position={{ vertical: POS_TOP, horizontal: POS_RIGHT }}
        style={{ top: '65px' }}
      />
      <TemplateTables />
    </StateProvider>
  )
}
